(ns dashboard.components.tag
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [dashboard.utils :refer [cs href]]))

(defn tag [{:keys [color interactive? class intent]} & children]
  [:span.inline-flex.items-center.px-3.rounded-full.text-sm.font-medium
   {:class (cs "py-0.5"
               (if (some? intent)
                 (str "bg-" intent " " "text-white")
                 (if (some? color)
                   (str "bg-" color "-100" " " "text-" color "-800")
                   "bg-gray-100 text-gray-800"))
               (when interactive?
                 (if (some? color)
                   (str "hover:bg-" color "-200")
                   "hover:bg-gray-200")))}
   `[:span
     ~@children]])
